const initialState = {
  userPreferenceData: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_USER_PREFERENCE':
      return {
        ...state,
        userPreferenceData: action.data,
      }
    default:
      return state
  }
}
